import React, { FC, ReactNode, useState } from 'react';
import { EventDetailsContext } from './context';
import { ActiveType } from 'pages/get-started/add-your-team';
import { GuestDetailsType } from 'models/guest.model';
import { CreateEventFormType } from 'models/event.model';

const defaultImage =
  'https://d3u7b9fq2opvwp.cloudfront.net/upload-service/663b1a5a-e6ce-4d3f-b276-9f01ceab5b87:eventscopy%202.png';

const EventDetailsProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const rangeKey = 'selection';
  const [newGuestData, setNewGuestData] = useState<GuestDetailsType[]>([]);
  const [formData, setFormData] = useState<CreateEventFormType>({
    name: '',
    description: '',
    start_date: '',
    end_date: '',
    key: rangeKey,
    event_picture: defaultImage,
    guests: newGuestData,
    budget: '0'
  });
  const [active, setActive] = useState<ActiveType | null>(null);
  const [disabled, setDisabled] = useState(true);
  const [isFormEmpty, setIsFormEmpty] = useState(true);

  return (
    <EventDetailsContext.Provider
      value={{
        loading,
        setLoading,
        formData,
        setFormData,
        newGuestData,
        setNewGuestData,
        active,
        setActive,
        disabled,
        setDisabled,
        isFormEmpty,
        setIsFormEmpty
      }}>
      {children}
    </EventDetailsContext.Provider>
  );
};

export default EventDetailsProvider;
